module.exports = __webpack_public_path__ + "static/img/5.ed6d440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/5.jpg
// module id = 9lPz
// module chunks = 1